module.exports = __webpack_public_path__ + "img/218641c.jpg";